"use client"

import { AdaptiveOverlay } from "@src/components/AdaptiveOverlay"
import InternalAddressView from "@src/components/InternalAddressView"
import { InternalBadge } from "./DefuseSDK/components/Network/InternalBadge"
import Drawer from "./Drawer"

export function AddressOverlay({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  return (
    <AdaptiveOverlay
      open={open}
      onClose={onClose}
      mobile={{
        type: "drawer",
        props: {
          header: (
            <Drawer.Title>
              <AddressTitle />
            </Drawer.Title>
          ),
        },
      }}
      desktop={{
        type: "dialog",
        props: {
          size: "lg",
          title: <AddressTitle />,
        },
      }}
    >
      <InternalAddressView />
    </AdaptiveOverlay>
  )
}

const AddressTitle = () => (
  <span className="flex items-center gap-2.5">
    <span className="text-pretty font-semibold text-gray-900 text-xl/7 tracking-tight dark:text-white">
      Your near.com<span className="sr-only"> internal</span> address
    </span>
    <span aria-hidden="true">
      <InternalBadge size="sm" />
    </span>
  </span>
)
